import { render, staticRenderFns } from "./ConversationTagV2.vue?vue&type=template&id=2d411327"
import script from "./ConversationTagV2.vue?vue&type=script&lang=js"
export * from "./ConversationTagV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports